import Vue from 'vue';
import Router, {Route} from 'vue-router';
import Home from '@/views/Home.vue';
import About from '@/views/About.vue';
import LoginPage from '@/views/LoginPage.vue';

import Projects from '@/views/Projects.vue';
import ScenarioSelection from '@/views/ScenarioSelection.vue';

import {acOverlayRoutes, asphaltRoutes, concreteRoutes, porousRoutes} from '@/modules/design/designRouter';
import {lccaRoutes} from '@/modules/lcca/lccaRouter';
import ConvertReports from '@/views/ConvertReports.vue';
import NewProject from '@/views/NewProject.vue';
import {userStore} from '@/store/store';
import {agencyRoutes} from '@/modules/agencyCost/router';
import CreateUser from '@/views/components/home/CreateUser.vue';
import ResetPassword from '@/views/ResetPassword.vue';
import {clearAllHttpErrors} from '@/lib/util/errors';
import {perRoadRoutes} from '@/modules/perRoad/router';
import SharedScenarios from '@/views/SharedScenarios.vue';
import {structureRoutes} from "@/modules/structure/router";

Vue.use(Router);

const routeWhitelist = [
  '/',
  '/about',
  '/newUser',
  '/login',
  '/reset-password',
];

/*
 Redirect to home if not logged in
 */
export const loggedInRouteGuard = (to: Route, from: Route, next: Function) => {
  const routeIsInWhitelist: Boolean = routeWhitelist.includes(to.path);

  if (userStore.userIsLoggedIn || routeIsInWhitelist) {
    userStore.reloadUser();
    next();
  } else {
    next({path: '/'});
  }
};

export const clearErrors = (to: Route, from: Route) => {
  clearAllHttpErrors('src/Router');
};

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      path: '/about',
      name: 'about',
      redirect: '/projects/1',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: About,
      // () =>
      // import(/* webpackChunkName: "about" */ "./views/About.vue")
    },
    {
      path: '/newUser',
      name: 'newUser',
      component: CreateUser,
    },
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: ResetPassword,
    },
    {
      path: '/projects',
      name: 'projects',
      component: Projects,
    },
    {
      path: '/shared',
      name: 'shared',
      component: SharedScenarios,
    },
    {
      path: '/newProject',
      name: 'newProject',
      component: NewProject,
    },
    {
      path: '/editProject/:id',
      name: 'editProject',
      component: NewProject,
      props: (route) => ({
        id: route.params.id,
      }),
    },
    {
      path: '/convert',
      name: 'convert',
      component: ConvertReports,
    },
    {
      path: '/projects/:id',
      name: 'ScenarioSelection',
      component: ScenarioSelection,
      props: (route) => ({
        pxProjectId: route.params.id,
      }),
    },
    asphaltRoutes,
    concreteRoutes,
    porousRoutes,
    acOverlayRoutes,
    lccaRoutes,
    perRoadRoutes,
    ...agencyRoutes,
    structureRoutes
  ],
});

router.beforeEach(loggedInRouteGuard);
router.afterEach(clearErrors);

export default router;

// console.log('Router created');
